
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"160","height":"161","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"80","cy":"80.063","r":"80","fill":"#1E1E1E"}}),_c('path',{attrs:{"d":"M42.03 76.04h74.462v57.581a.44.44 0 01-.44.442H42.469a.439.439 0 01-.44-.442v-57.58z","fill":"#636363"}}),_c('path',{attrs:{"d":"M97.812 53.477H63.188L42.03 76.04h74.463l-18.68-22.564z","fill":"#4F4F4F"}}),_c('path',{attrs:{"d":"M49.082 44.451l14.106 9.026L42.03 76.04 26 63.79l23.082-19.34zM111.918 44.451l-14.106 9.026 18.68 22.564L135 63.79l-23.082-19.34z","fill":"#636363"}}),_c('path',{attrs:{"d":"M72.285 44.912c.398-.19.707-.526.864-.94a1.725 1.725 0 00-.024-1.281L66.78 27.646a1.718 1.718 0 00-.964-.934 1.699 1.699 0 00-1.339.053l-1.222.583a1.71 1.71 0 00-.889 1.008 1.724 1.724 0 00.109 1.342l7.568 14.463a1.699 1.699 0 002.243.752zM80.24 43.454c.288-.02.557-.152.751-.368a1.13 1.13 0 00.289-.788l-.314-10.71a1.131 1.131 0 00-.754-1.032 1.113 1.113 0 00-.444-.058l-.885.063a1.115 1.115 0 00-.993.8 1.13 1.13 0 00-.04.45l1.198 10.647c.033.288.175.553.397.739.222.185.507.278.795.257zM86.382 47.413c.792.461 1.905.038 2.522-.958L99.86 28.764c.654-1.057.499-2.345-.341-2.834l-1.172-.681c-.84-.489-2.028.019-2.613 1.116L85.95 44.737c-.55 1.035-.36 2.216.432 2.676z","fill":"#999"}})])
          )
        }
      }
    